import React from 'react';
import { Box, Button, Text } from '@chakra-ui/react';
import * as Yup from 'yup';
import { useGameColorsProvider } from '../../../providers/Theme/gameColorsProvider';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Color } from 'src/theme/color';
import Vendor from '../../../vendor.config';

//@ts-ignore
export const handleNewsletterRedirect = () => window.open(Vendor.data.externalUri.newsletter, '_blank').focus();

export const Newsletter = ({
	loading,
	headerText,
	headerStyle,
	isDisabledButton,
	onSend,
	customBorderStyle,
	handleCheckbox,
	isCheckedForNewsletter,
	buttonColor,
}: {
	onSend?: any;
	isDisabledButton?: boolean;
	loading: boolean;
	headerText?: string;
	headerStyle?: any;
	customBorderStyle?: string;
	isCheckedForNewsletter?: boolean;
	buttonColor?: string;
	handleCheckbox?: (event: any) => void;
}) => {
	const { callToActionColor, textColor } = useGameColorsProvider();
	const { t } = useTranslation();
	const navigate = useNavigate();

	const SighupSchema = Yup.object().shape({
		email: Yup.string()
			.email(t('default.wrongEmail').toString())
			.min(2, t('default.toShort').toString())
			.max(50, t('default.toLong').toString())
			.required(t('default.required').toString()),
	});

	const goToStatute = (event: any) => {
		event.stopPropagation();
		event.preventDefault();
		navigate('/statute');
	};

	return (
		<Box>
			<Text
				mb="15px"
				{...headerStyle}
			>
				{headerText ? t(headerText) : t('footer.newsletter').toUpperCase()}
			</Text>

			<Button
				fontSize="12px"
				fontWeight="800"
				p="0 25px"
				height="4em"
				borderRightRadius="5px"
				_hover={{ background: buttonColor }}
				disabled={loading || isDisabledButton}
				type="submit"
				color="white"
				cursor="pointer"
				background={Color.ACTION}
				textTransform="uppercase"
				width="100%"
				onClick={handleNewsletterRedirect}
			>
				<Text>Newsletter signup</Text>
			</Button>
		</Box>
	);
};
